import { DataBean } from "../../DataBean";


export class CreateProvision extends DataBean {

    public async createProvisionAccounting(idProvisionData: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_createProvisionAccounting_Number_Number", [idProvisionData, idEmployee]);
    }

}